import React, {useState} from 'react';
import './Hero.css';
import PlayVideo from '../../../../assets/Images/svg/play-video.svg';
import Filtrex from '../../../../assets/Images/svg/Filtrix final.svg';
import asset from '../../../../assets/Images/home/asset.png';
import { Row, Col, Modal } from "react-bootstrap";
import { Link } from 'react-router-dom';

const Hero = ({ url, section }) => {
  const { hero_title, hero_subtitle, hero_button, how_to_use, item_groups } = section.data;

  const [showVideoModal, setShowVideoModal] = useState(false);

  const getEmbedUrl = (url) => {
    if (url.includes("watch?v=")) {
      const videoId = url.split("watch?v=")[1].split("&")[0];
      return `https://www.youtube.com/embed/${videoId}`;
    }
    if (url.includes("youtu.be")) {
      const videoId = url.split("youtu.be/")[1].split("?")[0];
      return `https://www.youtube.com/embed/${videoId}`;
    }
    return url; // Return the URL if it's already in the embed format
  };
  

  // Convert the demo video URL to embed format if it exists
  const embedVideoUrl = getEmbedUrl("https://youtu.be/-Rd445c2XdU?si=ZQ7XV7bJRMznOCus");


  const handleShowVideo = () => {
    setShowVideoModal(true);
  };

  const handleCloseVideo = () => {
    setShowVideoModal(false);
  };

  return (
    <div className="home-hero">
      <div className="hero-title">
        <p dangerouslySetInnerHTML={{ __html: hero_title }}></p>
      </div>
      <div className="hero-text">{hero_subtitle}</div>
      <div className="flex-div">
        <button
          className="hero-btn"
          onClick={() => (window.location.href = '/products')}
        >
          {hero_button}
        </button>
        <div className="video-link" onClick={handleShowVideo}>
          <img src={PlayVideo} alt="Play Video" />
          <span>{how_to_use}</span>
        </div>
      </div>

      <div className="features">
        <div className="start-with">
          <span className="start">Start with</span>
          <img src={Filtrex} alt="Filtrex Logo" />
        </div>

        <div className="features-div">
          {item_groups &&
            item_groups.map((item, index) => (
              <a
                href={"/products"}
                className="feature-card"
                key={index}
               
              >
                <img
                  src={item.image ? `${url}/${item.image}` : asset}
                  alt={item.name}
                />
                <span className="feature-text">{item.name}</span>
              </a>
            ))}
        </div>
      </div>

      {/* Video Modal */}
      <Modal show={showVideoModal} onHide={handleCloseVideo} centered dialogClassName="use-modal-width">
        <Modal.Header closeButton>
          <Modal.Title>Product Demo</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <iframe
              width="900"
              height="500"
              src={embedVideoUrl}
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Hero;
